export const normalizeUrl = (urlString: string | undefined) => {
  try {
    let updStr = urlString as string
    if (!updStr.match(/^https?:\/\//)) {
      updStr = 'https://' + updStr
    }

    const url = new URL(updStr)

    url.hostname = url.hostname.toLowerCase()

    url.hash = ''

    return url.toString()
  } catch (_e) {
    return urlString
  }
}
